// extracted by mini-css-extract-plugin
module.exports = {"cont_pr_logos":"PRLogo_cont_pr_logos__72nrs","content":"PRLogo_content__1W14l","text_pr_logo":"PRLogo_text_pr_logo__2CVaY"};